import React from 'react';
import { useDrag } from 'react-dnd';
import Dragicon from 'src/assets/images/common/drag.svg';

const style = {
  cursor: 'move',
  display: 'flex',
  gap: '10px'
};

const DraggableItem = ({ itemId, content, rightDrag }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'ITEM',
    item: { id: itemId },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  return (
    <div
      ref={drag}
      className="align-items-start p-1"
      style={{ ...style, opacity: isDragging ? 0.5 : 1, justifyContent: rightDrag ? 'space-between' : '' }}
    >
      {rightDrag ? (
        <>
          {content}
          <img src={Dragicon} alt="draggable" className="wid-8" />
        </>
      ) : (
        <>
          <img src={Dragicon} alt="draggable" className="wid-8" /> {content}
        </>
      )}
    </div>
  );
};

export default DraggableItem;
